import { isFlagEnabled } from "js/utilities";
import { default as ReleasingMakeAPayment } from "./make-a-payment";
import DeprecatedMakeAPayment from "./Deprecated-make-a-payment";

export default function policies() {
  return isFlagEnabled("ENABLE_MAKE_A_PAYMET_WITH_LOAN_BALANCE") ? (
    <ReleasingMakeAPayment />
  ) : (
    <DeprecatedMakeAPayment />
  );
}
